// @flow
import { Dispatch } from 'redux';

import type { Action } from './redux';
import type { VehicleTaxPlan } from '../lib/types';

export const SET_SELF_VEHICLE_TAX_PLAN = 'vehicleTaxPlan/self/set';
export const SET_PLANNED_VEHICLE_TAX_PLAN = 'vehicleTaxPlan/planned/set';

export const DEL_SELF_VEHICLE_TAX_PLAN = 'vehicleTaxPlan/self/delete';
export const DEL_PLANNED_VEHICLE_TAX_PLAN = 'vehicleTaxPlan/planned/delete';

export type VehicleTaxPlanState = {
  selfVehicles: ?Map<number, VehicleTaxPlan>,
  plannedVehicles: ?Map<number, VehicleTaxPlan>
};

const initialState: VehicleTaxPlanState = {
  selfVehicles: new Map(),
  plannedVehicles: new Map()
};

const reducer = (
  state: VehicleTaxPlanState = initialState,
  { type, payload }: Action
) => {
  switch (type) {
    case SET_SELF_VEHICLE_TAX_PLAN:
      return {
        ...state,
        selfVehicles: new Map<number, VehicleTaxPlan>(payload)
      };
    case SET_PLANNED_VEHICLE_TAX_PLAN:
      return {
        ...state,
        plannedVehicles: new Map<number, VehicleTaxPlan>(payload)
      };
    case DEL_SELF_VEHICLE_TAX_PLAN:
      return {
        ...state,
        selfVehicles: new Map<number, VehicleTaxPlan>(payload)
      };
    case DEL_PLANNED_VEHICLE_TAX_PLAN:
      return {
        ...state,
        plannedVehicles: new Map<number, VehicleTaxPlan>(payload)
      };
    default:
      return state;
  }
};

export const addVehicleTaxPlanVehicle = (
  vehicleTaxPlan: Map<number, VehicleTaxPlan>,
  self: boolean = true
) => async (dispatch: Dispatch) => {
  dispatch({
    type: self ? SET_SELF_VEHICLE_TAX_PLAN : SET_PLANNED_VEHICLE_TAX_PLAN,
    payload: vehicleTaxPlan
  });
};

export const setVehicleTaxPlanVehicle = (
  vehicleTaxPlan: Map<number, VehicleTaxPlan>,
  self: boolean = true
) => async (dispatch: Dispatch) => {
  dispatch({
    type: self ? SET_SELF_VEHICLE_TAX_PLAN : SET_PLANNED_VEHICLE_TAX_PLAN,
    payload: vehicleTaxPlan
  });
};

export const deleteVehicleTaxPlanVehicle = (
  vehicleTaxPlan: Map<number, VehicleTaxPlan>,
  self: boolean = true
) => async (dispatch: Dispatch) => {
  dispatch({
    type: self ? DEL_SELF_VEHICLE_TAX_PLAN : DEL_PLANNED_VEHICLE_TAX_PLAN,
    payload: vehicleTaxPlan
  });
};

export default reducer;
